import React, { useEffect } from "react";
import styled from "styled-components";
import InteractiveContext from "views/components/contexts/InteractiveContext";
import BigDisplayModeHeader from "views/components/dashboard/BigDisplayModeHeader";
import CycleQueryTab from "views/components/dashboard/bigdisplay/CycleQueryTab";
import useAutoRefresh from "views/hooks/useAutoRefresh";
import useQuery from "routing/useQuery";
import ShowViewPage from "./ShowViewPage";
const castQueryWithDefaults = ({ tabs, interval, refresh }) => ({
  tabs: tabs !== void 0 ? tabs.split(",").map((tab) => Number.parseInt(tab, 10)) : void 0,
  interval: interval !== void 0 ? Math.max(Number.parseInt(interval, 10), 1) : 30,
  refresh: refresh !== void 0 ? Math.max(Number.parseInt(refresh, 10), 1) : 10
});
const BodyPositioningWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
`;
const AutoRefreshSearch = ({ refreshInterval }) => {
  const { startAutoRefresh, stopAutoRefresh } = useAutoRefresh();
  useEffect(() => {
    startAutoRefresh(refreshInterval * 1e3);
    return () => {
      stopAutoRefresh();
    };
  }, [refreshInterval, startAutoRefresh, stopAutoRefresh]);
  return null;
};
const ShowDashboardInBigDisplayMode = () => {
  const query = useQuery();
  const configuration = castQueryWithDefaults(query);
  return /* @__PURE__ */ React.createElement(InteractiveContext.Provider, { value: "disabled" }, /* @__PURE__ */ React.createElement(BodyPositioningWrapper, null, /* @__PURE__ */ React.createElement(ShowViewPage, null, /* @__PURE__ */ React.createElement(AutoRefreshSearch, { refreshInterval: configuration.refresh }), /* @__PURE__ */ React.createElement(CycleQueryTab, { interval: configuration.interval, tabs: configuration.tabs }), /* @__PURE__ */ React.createElement(BigDisplayModeHeader, null))));
};
export default ShowDashboardInBigDisplayMode;
